import { createFileRoute } from '@tanstack/react-router';

import { PoliciesPage } from '../../features/policies';

export const Route = createFileRoute('/_agent/policies/')({
  component: PoliciesPage,
});
